var _circle, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#178F4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(4 4)",
    fill: "#178F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1934 15.3021C9.91081 15.3021 9.67535 15.1897 9.48698 14.9648L7.13542 12.1165C7.05339 12.0224 6.99566 11.9312 6.96224 11.8431C6.92882 11.755 6.91211 11.6638 6.91211 11.5697C6.91211 11.3539 6.98351 11.1762 7.1263 11.0365C7.27214 10.8937 7.45443 10.8223 7.67318 10.8223C7.91623 10.8223 8.11827 10.921 8.2793 11.1185L10.1751 13.4655L13.8984 7.58203C13.9926 7.43924 14.0898 7.33898 14.1901 7.28125C14.2934 7.22049 14.4195 7.1901 14.5684 7.1901C14.7871 7.1901 14.9679 7.25998 15.1107 7.39974C15.2535 7.5395 15.3249 7.71571 15.3249 7.92838C15.3249 8.00738 15.3112 8.08941 15.2839 8.17448C15.2565 8.25955 15.214 8.34766 15.1563 8.4388L10.9134 14.9329C10.7463 15.179 10.5063 15.3021 10.1934 15.3021Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteStep);
export default __webpack_public_path__ + "static/media/complete_step.3284a924.svg";
export { ForwardRef as ReactComponent };